"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _popover = _interopRequireDefault(require("@clds/popover"));
var _menu = require("@clds/menu");
var _DropdownMenu = require("./DropdownMenu.hooks");
var _useDropdownMenu = require("./headless/useDropdownMenu");
var _useDropdownMenuState = require("./headless/useDropdownMenuState");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DropdownMenu = ({
  defaultOpened,
  isOpened,
  onOpenedChange,
  children,
  items,
  onSelect,
  minWidth,
  maxWidth,
  maxHeight,
  defaultFocusedId,
  defaultSelectedId,
  focusedId,
  selectedId,
  onFocusedIdChange,
  focusOnClose = true,
  triggerAction = 'click',
  'data-test-specifier': dataTestSpecifier = '',
  ...rest
}) => {
  const explicitSelectionState = (0, _DropdownMenu.useExplicitSelectionState)({
    defaultSelectedId,
    selectedId,
    onSelect
  });
  const menuState = (0, _menu.useMenuState)({
    defaultFocusedId,
    focusedId,
    onFocusedIdChange,
    ...explicitSelectionState
  });
  const dropdownMenuState = (0, _useDropdownMenuState.useDropdownMenuState)({
    defaultOpened,
    isOpened,
    onOpenedChange
  }, menuState);
  const dropdownMenu = (0, _useDropdownMenu.useDropdownMenu)({
    items,
    trigger: children,
    focusOnClose
  }, dropdownMenuState);
  const menu = /*#__PURE__*/_react.default.createElement(_menu.Menu, _extends({
    variant: {
      selectionVariant: 'subtle',
      borderRadius: 'md'
    }
  }, dropdownMenu.menuProps, {
    maxHeight: maxHeight,
    ref: dropdownMenu.navigationRef,
    "data-test": "menu"
  }), dropdownMenu.connectedItems);
  return /*#__PURE__*/_react.default.createElement(_popover.default, _extends({
    placement: "bottomRight",
    animation: "zoom",
    trigger: triggerAction,
    minWidth: minWidth,
    maxWidth: maxWidth,
    paperProps: {
      isPadded: false,
      borderRadius: 'md'
    },
    overlay: menu,
    "data-test-specifier": `dropdown-menu${dataTestSpecifier ? '-' + dataTestSpecifier : ''}`
  }, dropdownMenu.popoverProps, rest), dropdownMenu.connectedTrigger);
};
exports.DropdownMenu = DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map